import React, { useEffect } from "react";
import { useI18n } from "@/lib/i18n";
import PageTitle from "@/components/PageTitle";

const CookiesPage = () => {
  const { t } = useI18n();
  useEffect(() => {
    document.title = t("pageTitles.cookies");
  }, [t]);

  const SECTIONS = ["what", "types", "consent", "manage", "contact"];

  return (
    <main data-testid="cookies-page" className="bg-white">
      <PageTitle
        title={t("cookies.page.title")}
        subtitle={t("pageHeader.cookiesSubtitle")}
        breadcrumbKey="cookies"
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <p className="text-sm text-slate-500">{t("cookies.page.updated")}</p>
        <p className="mt-6 text-base text-slate-700 leading-relaxed">
          {t("cookies.page.intro")}
        </p>

        <div className="mt-10 space-y-10">
          {SECTIONS.map((key) => (
            <section key={key} data-testid={`cookies-section-${key}`}>
              <h2 className="font-heading text-xl sm:text-2xl font-semibold text-slate-900">
                {t(`cookies.page.sections.${key}.title`)}
              </h2>
              {key === "types" ? (
                <ul className="mt-3 space-y-2 list-disc pl-5 text-slate-700">
                  {["necessary", "analytics", "marketing", "preferences"].map((i) => (
                    <li key={i} className="leading-relaxed">
                      {t(`cookies.page.sections.types.items.${i}`)}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="mt-3 text-base text-slate-700 leading-relaxed">
                  {t(`cookies.page.sections.${key}.body`)}
                </p>
              )}
            </section>
          ))}
        </div>
      </div>
    </main>
  );
};

export default CookiesPage;
